module.exports = __webpack_public_path__ + "static/media/24PerformancePhotos.2c5a65d7.jpeg";